import React from "react";
import { Heading } from 'apps/sigma2-ui/src/components/ui/Heading';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const ErrorFallback: React.FC<{ message: string }> = ({ message }) => {
  return (
    <Spacing direction="vertical" size="xs" className="p-5">
      <Heading level={2}>Error</Heading>
      <Paragraph>{message}</Paragraph>
    </Spacing>
  );
};
